import Svg from 'components/utilities/svg'

const LightBulbIcon = ({ ...props }) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <title>Light Bulb Icon</title>
    <path d="M12 22q-.825 0-1.412-.587Q10 20.825 10 20h4q0 .825-.587 1.413Q12.825 22 12 22Zm-4-3v-2h8v2Zm.25-3q-1.725-1.025-2.737-2.75Q4.5 11.525 4.5 9.5q0-3.125 2.188-5.312Q8.875 2 12 2q3.125 0 5.312 2.188Q19.5 6.375 19.5 9.5q0 2.025-1.012 3.75-1.013 1.725-2.738 2.75Z" />
  </Svg>
)

LightBulbIcon.displayName = 'Light Bulb'

export default LightBulbIcon
